// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ids-expandable-area {
  border-bottom: var(--ids-expandable-area-border-bottom);
  padding: calc(var(--ids-space-xs) * 3) var(--ids-space-none);
}
.ids-expandable-area .expandable-pane-content {
  margin-block-start: calc(var(--ids-space-xs) * 2);
}
.ids-expandable-area .expandable-pane-content.child-form {
  margin-block-start: unset;
}

:host([no-padding]) .ids-expandable-area {
  padding: 0;
  border-bottom: none;
}

:host([child-form]) .ids-expandable-area {
  border-bottom: none;
}
:host([child-form]) .ids-expandable-area-pane {
  padding-inline-start: 24px;
}
:host([child-form]) .ids-expandable-area-footer {
  display: none;
}

:host([child-form][expanded]) .ids-expandable-area {
  border-bottom: none;
  background: var(--ids-expandable-area-child-form-color-background);
  border-radius: 8px;
}

:host([child-form][expanded][invert-color-fill]) .ids-expandable-area {
  background: var(--ids-expandable-area-child-form-invert-color-background);
}

:host([type=toggle-btn]) .ids-expandable-area-header {
  margin-block-end: var(--ids-space-xs);
}

:host([type=partial]) .ids-expandable-area-visible-pane .expandable-pane-content {
  margin-block-start: calc(var(--ids-space-xs) * 3);
}
:host([type=partial]) .ids-expandable-area-pane .expandable-pane-content {
  margin-block-start: var(--ids-space-none);
}

.ids-expandable-area-header ::slotted(ids-text) {
  display: block;
  margin-block-end: var(--ids-space-xs);
}

.ids-expandable-area-footer ::slotted(ids-hyperlink),
.ids-expandable-area-footer ::slotted(ids-text) {
  display: block;
  margin-block-start: var(--ids-space-none);
  margin-block-end: calc(var(--ids-space-xs) * -1);
}

[data-expander=link] {
  display: inline-block;
}
[data-expander=link][aria-expanded=true] {
  margin-block-start: var(--ids-space-xs);
}

[data-expander=header] {
  pointer-events: none;
}

[data-expander=header] [name=header] {
  pointer-events: initial;
}

.ids-expandable-area-pane {
  height: var(--ids-space-none);
  overflow: hidden;
  transition: height var(--ids-motion-duration) var(--ids-motion-linear);
}

:host(.ids-date-picker-expandable) .ids-expandable-area .ids-expandable-area-pane {
  transition: height var(--ids-motion-datepicker-duration) var(--ids-motion-linear);
}`, "",{"version":3,"sources":["webpack://./src/components/ids-expandable-area/ids-expandable-area.scss"],"names":[],"mappings":"AAEA;EACE,uDAAA;EACA,4DAAA;AADF;AAGE;EACE,iDAAA;AADJ;AAGI;EACE,yBAAA;AADN;;AAOE;EACE,UAAA;EACA,mBAAA;AAJJ;;AASE;EACE,mBAAA;AANJ;AASE;EACE,0BAAA;AAPJ;AAUE;EACE,aAAA;AARJ;;AAcE;EACE,mBAAA;EACA,kEAAA;EACA,kBAAA;AAXJ;;AAgBE;EACE,yEAAA;AAbJ;;AAkBE;EACE,qCAAA;AAfJ;;AAoBE;EACE,iDAAA;AAjBJ;AAoBE;EACE,yCAAA;AAlBJ;;AAsBA;EACE,cAAA;EACA,qCAAA;AAnBF;;AAsBA;;EAEE,cAAA;EACA,yCAAA;EACA,gDAAA;AAnBF;;AAsBA;EACE,qBAAA;AAnBF;AAqBE;EACE,uCAAA;AAnBJ;;AAuBA;EACE,oBAAA;AApBF;;AAuBA;EACE,uBAAA;AApBF;;AAuBA;EACE,6BAAA;EACA,gBAAA;EACA,sEAAA;AApBF;;AAwBA;EACE,iFAAA;AArBF","sourcesContent":["@use '../../themes/mixins/ids-core-mixins' as mixins;\n\n.ids-expandable-area {\n  border-bottom: var(--ids-expandable-area-border-bottom);\n  padding: calc(var(--ids-space-xs) * 3) var(--ids-space-none);\n\n  .expandable-pane-content {\n    margin-block-start: calc(var(--ids-space-xs) * 2);\n\n    &.child-form {\n      margin-block-start: unset;\n    }\n  }\n}\n\n:host([no-padding]) {\n  .ids-expandable-area {\n    padding: 0;\n    border-bottom: none;\n  }\n}\n\n:host([child-form]) {\n  .ids-expandable-area {\n    border-bottom: none;\n  }\n\n  .ids-expandable-area-pane {\n    padding-inline-start: 24px;\n  }\n\n  .ids-expandable-area-footer {\n    display: none;\n  }\n}\n\n\n:host([child-form][expanded]) {\n  .ids-expandable-area {\n    border-bottom: none;\n    background: var(--ids-expandable-area-child-form-color-background);\n    border-radius: 8px;\n  }\n}\n\n:host([child-form][expanded][invert-color-fill]) {\n  .ids-expandable-area {\n    background: var(--ids-expandable-area-child-form-invert-color-background);\n  }\n}\n\n:host([type='toggle-btn']) {\n  .ids-expandable-area-header {\n    margin-block-end: var(--ids-space-xs);\n  }\n}\n\n:host([type='partial']) {\n  .ids-expandable-area-visible-pane .expandable-pane-content {\n    margin-block-start: calc(var(--ids-space-xs) * 3);\n  }\n\n  .ids-expandable-area-pane .expandable-pane-content {\n    margin-block-start: var(--ids-space-none);\n  }\n}\n\n.ids-expandable-area-header ::slotted(ids-text) {\n  display: block;\n  margin-block-end: var(--ids-space-xs);\n}\n\n.ids-expandable-area-footer ::slotted(ids-hyperlink),\n.ids-expandable-area-footer ::slotted(ids-text) {\n  display: block;\n  margin-block-start: var(--ids-space-none);\n  margin-block-end: calc(var(--ids-space-xs) * -1); // -8px\n}\n\n[data-expander='link'] {\n  display: inline-block;\n\n  &[aria-expanded='true'] {\n    margin-block-start: var(--ids-space-xs);\n  }\n}\n\n[data-expander='header'] {\n  pointer-events: none;\n}\n\n[data-expander='header'] [name='header'] {\n  pointer-events: initial;\n}\n\n.ids-expandable-area-pane {\n  height: var(--ids-space-none);\n  overflow: hidden;\n  transition: height var(--ids-motion-duration) var(--ids-motion-linear);\n}\n\n// Faster transition for date picker only\n:host(.ids-date-picker-expandable) .ids-expandable-area .ids-expandable-area-pane {\n  transition: height var(--ids-motion-datepicker-duration) var(--ids-motion-linear);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
